import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface AppState {
    sidebarCollapsed: boolean;
    globalLoading: boolean;
}

const initialState: AppState = {
    sidebarCollapsed: false,
    globalLoading: false,
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.sidebarCollapsed = !state.sidebarCollapsed;
        },
        setSidebarState: (state, action: PayloadAction<boolean>) => {
            state.sidebarCollapsed = action.payload;
        },
        setGlobalLoading: (state, action: PayloadAction<boolean>) => {
            state.globalLoading = action.payload;
        },
    },
});

export const { toggleSidebar, setSidebarState, setGlobalLoading } = appSlice.actions;
export default appSlice.reducer;
